import {useEffect} from 'react';
import {WidgetProps} from '@wix/yoshi-flow-editor';
import {
  PreloadMessageSource,
  PreloadMessageType,
  type LoadCartMessage,
  type PreloadReadyMessage,
} from '../../../domain/preload/messages';
import {CheckoutControllerProps} from '../../../types/checkoutApp.types';

export const usePreloadListener = (controllerProps: WidgetProps<CheckoutControllerProps>): void => {
  const isPreload = controllerProps?.isPreload ?? false;
  const loadCartById = controllerProps?.navigationStore?.loadCartById;

  useEffect(() => {
    if (!isPreload || !loadCartById) {
      return;
    }

    const handler = (event: MessageEvent): void => {
      if (event.source !== window.parent) {
        return;
      }
      const data = event.data as Partial<LoadCartMessage>;
      if (data?.source !== PreloadMessageSource.Host || data.type !== PreloadMessageType.LoadCart) {
        return;
      }
      const cartId = data.payload?.cartId;
      if (cartId) {
        void loadCartById(cartId);
      }
    };

    window.addEventListener('message', handler);

    const ready: PreloadReadyMessage = {source: PreloadMessageSource.Viewer, type: PreloadMessageType.Ready};
    window.parent?.postMessage(ready, '*');

    return () => window.removeEventListener('message', handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPreload, !loadCartById]);
};
